import keys from "./keys";
import coalesce from "./coalesce";
function shallowMerge(a, b) {
  const bKeys = keys(b);
  const merged = { ...a };
  bKeys.forEach((key) => {
    merged[key] = coalesce(merged[key], b[key]);
  });
  return merged;
}
export {
  shallowMerge as default
};
//# sourceMappingURL=shallowMerge.js.map